module.exports = __webpack_public_path__ + "img/eight3Red.614e260d.jpg";